var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};



$( document ).ready(function() {
	var match_var="";

    $(document).on('click','.add_to_cart_col',function(e){
		e.preventDefault();
        console.log("clicked");
		var variant_id = $(this).closest(".collection-item__content").find(".pro_title").attr("data-variant-id");
		$.ajax({
		type: 'POST',
		url: '/cart/add.js',
		data:{
			id:variant_id,
			quantity: 1
		},
		dataType: 'json',
		}).done(function() { 
$('cart-drawer').load(location.href + " #CartDrawer");
setTimeout(function() {
$('cart-drawer').removeClass('is-empty').addClass("active");

}, 1000);
		});
	});

	$(document).on('change','.product__variant-wrapper .option-selector[type="radio"]',function(e){
		e.preventDefault();
		let value = $(this).val();
		$(this).prop('checked', true).siblings().prop('checked', false);
		var selectedText = "";
		$(this).parents(".variant-div").find(".single-product__option-wrapper").each(function () {
			$(this).find(".product__variant-wrapper .option-selector").each(function () {
				let e_val = $(this).val();
				if ($(this).is('.option-selector[type="radio"]:checked')) {
					var currentValue = $.trim($(this).val());
					if (selectedText !== null && selectedText !== "") {
						selectedText = selectedText + " / " + currentValue;
					} else {
						selectedText = currentValue;
					}
				}
			});
		});
		
		
		if (typeof selectedText !== "undefined" && selectedText !== null && selectedText !== "") {
		  var parentFormWrapper = $(this).closest('.variant-div');
		  var selectDropdown = $(parentFormWrapper).find('select[name="id"]');
		  if (selectDropdown.length > 0) {
			  selectDropdown.find('option').each(function () {
				  var currentText = $.trim($(this).text());
				  if (currentText === selectedText) {
					  selectDropdown.val($(this).val()).trigger("change");
					  $(this).addClass('selected').siblings().removeClass('selected');
				  }
			  });
		  }
	  }
	});
	$(document).on('change', ".variant-div select[name='id']", function (e) {
		var selected_var = $(this).children("option:selected").val().split('/');
		var match_var = selected_var[0] +"/"+selected_var[1];
		var price = $(this).children("option:selected").attr("data-price")/100;
		var price_without_money = $(this).children("option:selected").attr("data-price-without-money");
		var compare_price = $(this).children("option:selected").attr("data-compare-price")/100;
		var variant_img = $(this).children("option:selected").attr("data-img-src");
		var variant_id = $(this).children("option:selected").attr("data-variantid");
		var inventory = $(this).children("option:selected").attr("data-inventory"); 
		//$(this).closest('.cwr-product-detail__right').find(".pro-price").text('£'+price);
		jQuery(".js-slide-for__content").slick('slickGoTo', 0);
		jQuery(".js-slide-for__content .slick-active").find('img').attr('src',variant_img);
		$(this).closest('.cwr-product-detail__right').find(".pro-price").text(price_without_money);
		if(compare_price > 0){
			$(this).closest('.cwr-product-detail__right').find(".compare_price").text('£'+compare_price);
			console.log('is comp price');
			$(this).closest('.cwr-product-detail__right').find(".compare_price").show();
			$(this).closest('.cwr-product-detail__right').find(".offer").show();
		}else{
			$(this).closest('.cwr-product-detail__right').find(".compare_price").hide();
			$(this).closest('.cwr-product-detail__right').find(".offer").hide();
			$(this).closest('.cwr-product-detail__right').find(".pro-price").text(price_without_money);
		}
		$(this).closest('.cwr-product-detail__right').find(".pro_id").text(variant_id);
		if(compare_price > price){
			var save_price = (compare_price - price).toFixed(2);
			$(this).closest('.cwr-product-detail__right').find(".save-price").text('£'+save_price);
			console.log('is comp price--');
		}else{
			$(this).closest('.cwr-product-detail__right').find(".offer").hide();
			$(this).closest('.cwr-product-detail__right').find(".compare_price").hide();
			$(this).closest('.cwr-product-detail__right').find(".pro-price").text(price_without_money);
			console.log('is not comp price--');
		}

		if($('.subscribe-option').length){		
			var checked_value = $('.subscribe-option-list__wrap input:checked').val();console.log(checked_value);
			if(checked_value == 'subscribe-save'){

				var listPrice = parseFloat(price);
				var discount_per = $('.subscribe-option .subscribe-option-list .subscribe_save .js-label .offer .discount_per').attr('data-discount');
				var discount  = parseFloat(discount_per);

				var final_price = (listPrice - ( listPrice * discount / 100 )).toFixed(2);
				var variant_orig_price = Shopify.formatMoney(final_price,window.upcartMoneyFormat);
				var original_pric = $(this).children("option:selected").attr("data-price");
				var original_price = Shopify.formatMoney(original_pric,window.upcartMoneyFormat);
				$(this).closest('.cwr-product-detail__right').find(".pro-price").text(original_price);	
				// replace subscription price for "demo-product" template
				

				if($('body.demo-product').length){	
					$('select.product__purchase-selling-plan.demo-selling-plan optgroup').each(function() {
						let variantId = $(this).data('variant-id');
						if (variantId == variant_id) {
							let subscriptionPrice = $(this).find('option').data('subscription-price');
							let savingPercentage = $(this).find('option').data('saving-percentage');
							let variantOriginalPrice = $(this).find('option').data('variant-price');
							$('.subscribe-option-list .js-subscribe-option .js-label .discount_per').text(savingPercentage);
                			$('.js-subscribe-popup .subscribe-popup__content .cwr-benefit .discount_per').text(savingPercentage);
                			$('.js-subscribe-popup .subscribe-popup__content .cwr-price-detail .offer span').text(savingPercentage);
							$('.js-subscribe-popup .subscribe-popup__content .cwr-price-detail .show_price .cwr_subscription_price').text(subscriptionPrice);
							$('.js-subscribe-popup .subscribe-popup__content .cwr-price-detail .show_price del').text(variantOriginalPrice);

							$('.js-subscribe-popup-onetime .subscribe-popup__content .cwr-price-detail .show_price').text(variantOriginalPrice);

							// new widget subscribe button
							$('.new_widget_block .subscription_s1 .subscribe_price_block s').text(variantOriginalPrice);
							$('.new_widget_block .subscription_s1 .subscribe_price_block .subs_price').html('<div class="save_label">Save ' +savingPercentage + '</div>' + subscriptionPrice);
							$('.new_widget_block .one_time_s2 .one_time_price').text(variantOriginalPrice);
						}
					})

					
				} else {
					$('.js-subscribe-popup .cwr-price-detail span.show_price').replaceWith('<span class="show_price"><del>'+ original_price +'</del>' + variant_orig_price + '</span>');
				}

				
			}else{
				var original_pric = $(this).children("option:selected").attr("data-price");
				console.log('original_pric-' + original_pric);
				var original_price = Shopify.formatMoney(original_pric,window.upcartMoneyFormat);
				$(this).closest('.cwr-product-detail__right').find(".pro-price").text(original_price);
				if($('body.demo-product').length){	
					$('select.product__purchase-selling-plan.demo-selling-plan optgroup').each(function() {
						//new widget price get
						let value = $(this).attr('label');
						let bagsName = value.split("/");
						let bagsLastName = bagsName[bagsName.length - 1].trim();
						let vPrice = $(this).attr('data-v-price');
						if (value.indexOf(match_var) !== -1) {
							console.log(bagsLastName,"value", vPrice);
							// $('.new_s2_onetime_price[data-bag-name="'+bagsLastName+'"]').text(vPrice);
						}
						
						let variantId = $(this).data('variant-id');

						if (variantId == variant_id) {
							let subscriptionPrice = $(this).find('option').data('subscription-price');
							let savingPercentage = $(this).find('option').data('saving-percentage');
							let variantOriginalPrice = $(this).find('option').data('variant-price');
							$('.subscribe-option-list .js-subscribe-option .js-label .discount_per').text(savingPercentage);
                			$('.js-subscribe-popup .subscribe-popup__content .cwr-benefit .discount_per').text(savingPercentage);
                			$('.js-subscribe-popup .subscribe-popup__content .cwr-price-detail .offer span').text(savingPercentage);
							$('.js-subscribe-popup .subscribe-popup__content .cwr-price-detail .show_price .cwr_subscription_price').text(subscriptionPrice);
							$('.js-subscribe-popup .subscribe-popup__content .cwr-price-detail .show_price del').text(variantOriginalPrice);

							$('.js-subscribe-popup-onetime .subscribe-popup__content .cwr-price-detail .show_price').text(variantOriginalPrice);
							
							// new widget price change
							$('.new_widget_block .one_time_s2 span.one_time_price').text(variantOriginalPrice);
							$('.new_widget_block .subscription_s1 span.subscribe_price_block s').text(variantOriginalPrice);
							$('.new_widget_block .subscription_s1 span.subscribe_price_block .subs_price').html('<div class="save_label">Save ' +savingPercentage + '</div>' + subscriptionPrice);
						}
					});
				} else {
					$('.js-subscribe-popup-onetime .cwr-price-detail span.show_price').replaceWith('<span class="show_price">' + original_price + '</span>');
				}
			}
		}
		var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant_id;
      	window.history.replaceState({path: newurl}, '', newurl);

		if(inventory > 0 && inventory > 50){
			$(this).closest('.cwr-product-detail__right').find(".add-tocart-text").text('Add to cart');
			$(this).closest('.cwr-product-detail__right').find(".add-to-cart").removeClass('out-stock');
			$(this).closest('.cwr-product-detail__right').find(".add-to-cart").removeClass('klaviyo-bis-trigger');

			$(".order-dispatch").addClass('in-Stock');
			$(".order-dispatch").removeClass('low-stock');
			$(".order-dispatch").removeClass('out-stock');
			$(".order-dispatch").removeClass('klaviyo-bis-trigger');

			$(".stock_check").text('In Stock!');
        }else if(inventory > 0 && inventory < 50 ){
			$(this).closest('.cwr-product-detail__right').find(".add-tocart-text").text('Add to cart');
			$(this).closest('.cwr-product-detail__right').find(".add-to-cart").removeClass('out-stock');
			$(this).closest('.cwr-product-detail__right').find(".add-to-cart").removeClass('klaviyo-bis-trigger');

			$(".stock_check").text('Low in Stock');
			$(".order-dispatch").addClass('low-stock');
			$(".order-dispatch").removeClass('in-Stock');
			$(".order-dispatch").removeClass('out-stock');
			$(".order-dispatch").removeClass('klaviyo-bis-trigger');

		}
		else{
			$(this).closest('.cwr-product-detail__right').find(".add-tocart-text").text('Notify Me When Available');
			$(this).closest('.cwr-product-detail__right').find(".add-to-cart").addClass('out-stock');
			$(this).closest('.cwr-product-detail__right').find(".add-to-cart").addClass('klaviyo-bis-trigger');

			$(".stock_check").text('Out of Stock');
			$(".order-dispatch").addClass('out-stock');
			$(".order-dispatch").removeClass('in-Stock');
			$(".order-dispatch").removeClass('low-stock');
			$(".order-dispatch").addClass('klaviyo-bis-trigger');



        }		
	});

	
	$(document).on('submit','#form_product_new',function(e){
		e.preventDefault();
		var variant_id = parseInt($(this).closest(".cwr-product-detail__right").find(".pro_id").text());
		var qty = parseInt($(this).closest(".cwr-product-btn").find("input").val());
		let quantity = Number($('.cwr-product-btn .counter input').val());
		// console.log('quantity',qty, 'quantity5', quantity);

		
		if($('.subscribe-option').length){			
			var checked_value = $('.subscribe-option-list__wrap input:checked').val();console.log(checked_value);
			if(checked_value == 'subscribe-save'){

				var selling_plan = $('.subscribe-dropdown').find('.dropdown option:selected').val();console.log('selling_plan ' + selling_plan);
				//var selling_plan = $(".appstle_sub_widget").attr('data-selected-selling-plan');
				$.ajax({
				type: 'POST',
				url: '/cart/add.js',
				data: {
					id:variant_id,
					quantity: quantity,
					selling_plan: selling_plan
				},
				dataType: 'json',
				}).done(function(item) { 
$('cart-drawer').load(location.href + " #CartDrawer");
setTimeout(function() {
$('cart-drawer').removeClass('is-empty').addClass("active");

}, 1000);
				});
			}else{
				$.ajax({
				type: 'POST',
				url: '/cart/add.js',
				data: {
					id:variant_id,
					quantity: quantity
				},
				dataType: 'json',
				}).done(function(item) { 
$('cart-drawer').load(location.href + " #CartDrawer");
setTimeout(function() {
$('cart-drawer').removeClass('is-empty').addClass("active");

}, 1000);
				});
			}		
		}else{
			$.ajax({
				type: 'POST',
				url: '/cart/add.js',
				data: {
					id:variant_id,
					quantity: quantity
				},
				dataType: 'json',
				}).done(function(item) { 
$('cart-drawer').load(location.href + " #CartDrawer");
setTimeout(function() {
$('cart-drawer').removeClass('is-empty').addClass("active");

}, 1000);
			});
		}
		
	});
	
	// Change defalut to one time
	setTimeout(function() {
		$('.new_widget_block input').each(function(ie,em){
			var get_val = $(em).val();
			if(get_val == 'one-time'){
				$(em).attr('checked', true).trigger('click');
				$(em).next('label').click();
				
			}else{
				$(em).prop('checked', false);
			}
		});
	},3000);

});